"use client";

import { c as _c } from "react/compiler-runtime";
import type { SocialPlatform } from "@repo/design-system/components/social-link";
import { SocialLink } from "@repo/design-system/components/social-link";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { getCurrentYear } from "@repo/design-system/utils/date-helpers";
import { useLanguage } from "~/translations/loader/use-language";
declare global {
  interface Window {
    // biome-ignore lint/suspicious/noExplicitAny: UC_UI is third party
    UC_UI: any;
  }
}
export default function FooterHungary() {
  const $ = _c(50);
  const t = useLanguage();
  let t0;
  if ($[0] !== t.footer_title_facebook) {
    t0 = {
      social: "facebook",
      href: "https://www.facebook.com/share/18YuBwg9Hm/",
      title: t.footer_title_facebook
    };
    $[0] = t.footer_title_facebook;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t.footer_title_linkedIn) {
    t1 = {
      social: "linkedin",
      href: "https://www.linkedin.com/company/e.on-hung-ria-zrt./posts/?feedView=all&viewAsMember=true",
      title: t.footer_title_linkedIn
    };
    $[2] = t.footer_title_linkedIn;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t.footer_title_instagram) {
    t2 = {
      social: "instagram",
      href: "https://www.instagram.com/eon.hu?igsh=MW0zbmwwcmIzbmVwZA==",
      title: t.footer_title_instagram
    };
    $[4] = t.footer_title_instagram;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t.footer_title_youTube) {
    t3 = {
      social: "youtube",
      href: "https://www.youtube.com/playlist?list=PLqU3C62WPplqKUi-oc064uGn7p7YsbjC0",
      title: t.footer_title_youTube
    };
    $[6] = t.footer_title_youTube;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t.footer_title_tiktok) {
    t4 = {
      social: "tiktok",
      href: "https://www.tiktok.com/@eon_hu?_t=8jvVBEZLWyH&_r=1",
      title: t.footer_title_tiktok
    };
    $[8] = t.footer_title_tiktok;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = [t0, t1, t2, t3, t4];
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const socials = t5;
  let t6;
  if ($[16] !== socials) {
    t6 = <div className="mb-7 flex h-8 items-center lg:mb-auto lg:h-auto">{socials.map(_temp)}</div>;
    $[16] = socials;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t.footer_imprint || $[19] !== t.footer_link_imprint) {
    t7 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href={t.footer_link_imprint}>{t.footer_imprint}</CustomLink></li>;
    $[18] = t.footer_imprint;
    $[19] = t.footer_link_imprint;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t.footer_privacyPolicy) {
    t8 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href="/privacy">{t.footer_privacyPolicy}</CustomLink></li>;
    $[21] = t.footer_privacyPolicy;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t.footer_link_termsOfUse || $[24] !== t.footer_termsOfUse) {
    t9 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href={t.footer_link_termsOfUse}>{t.footer_termsOfUse}</CustomLink></li>;
    $[23] = t.footer_link_termsOfUse;
    $[24] = t.footer_termsOfUse;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t.footer_contact || $[27] !== t.footer_link_contact) {
    t10 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href={t.footer_link_contact}>{t.footer_contact}</CustomLink></li>;
    $[26] = t.footer_contact;
    $[27] = t.footer_link_contact;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t.footer_PKI || $[30] !== t.footer_link_PKI) {
    t11 = <li><CustomLink blank={true} className="first:ml-0 md:mx-3" href={t.footer_link_PKI}>{t.footer_PKI}</CustomLink></li>;
    $[29] = t.footer_PKI;
    $[30] = t.footer_link_PKI;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t.footer_privacySettings) {
    t12 = <li><button className="cursor-pointer hover:underline md:mx-3" onClick={_temp2} type="button">{t.footer_privacySettings}</button></li>;
    $[32] = t.footer_privacySettings;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t7 || $[38] !== t8 || $[39] !== t9) {
    t13 = <ul className="mb-9 grid justify-start font-medium text-sm leading-6 md:flex md:w-[60%] md:justify-end lg:m-auto lg:flex-wrap lg:justify-start">{t7}{t8}{t9}{t10}{t11}{t12}</ul>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t7;
    $[38] = t8;
    $[39] = t9;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== t13 || $[42] !== t6) {
    t14 = <div className="flex flex-col md:flex-row md:justify-between lg:w-[70%] lg:gap-x-4">{t6}{t13}</div>;
    $[41] = t13;
    $[42] = t6;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  let t15;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <p>{`© E.ON SE ${getCurrentYear()}`}</p>;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  const t16 = `${t.client} Logo`;
  let t17;
  if ($[45] !== t16) {
    t17 = <div className="flex items-center justify-end gap-x-8 text-sm lg:gap-x-12 xl:gap-x-20">{t15}<CustomImage alt={t16} height={29} src="images/logo/logo_footer.svg" width={100} /></div>;
    $[45] = t16;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t14 || $[48] !== t17) {
    t18 = <footer className="flex w-full justify-center p-6 text-clientFont md:px-10 print:hidden"><div className="mx-auto flex w-full max-w-screen-xl flex-col justify-between lg:flex-row lg:justify-between">{t14}{t17}</div></footer>;
    $[47] = t14;
    $[48] = t17;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  return t18;
}
function _temp2() {
  return window.UC_UI?.showSecondLayer();
}
function _temp(entry) {
  return <SocialLink className="shadow-none grayscale hover:transform-none" href={entry.href} key={entry.href} social={entry.social} title={entry.title} />;
}